import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { addBodyWagesQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchAddBodyWegas/patchAddBodyWegasQuery.type';
import { addBodyWegesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchAddBodyWegas/patchAddBodyWegasQueryFunction';

export const patchAddBodyWegasQueryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  addBodyWagesQueryParams
> => ({
  mutationKey: ['patchAddBodyWegasQueryOption'],
  mutationFn: (params: addBodyWagesQueryParams) =>
    addBodyWegesQueryFunction(params),
});
